<template>
  <section class="cta-section">
    <div class="cta-bg">
      <div class="cta-grid-pattern"></div>
      <div class="cta-orb cta-orb-1"></div>
      <div class="cta-orb cta-orb-2"></div>
    </div>

    <div class="cta-content" data-reveal="scale">
      <h2 class="cta-title">
        {{ props.title || `${$t('landing.cta_title_pre')} ` }}
        <span v-if="!props.title" class="gradient-text">{{ $t('landing.cta_title_highlight') }}</span>
        {{ !props.title ? $t('landing.cta_title_post') : '' }}
      </h2>
      <p class="cta-subtitle">{{ props.subtitle || $t('landing.cta_subtitle') }}</p>
      <div class="cta-buttons">
        <NuxtLink :to="props.primaryCtaLink || (localePath('/auth') + '?tab=signup')" class="btn-cyber-primary btn-cta">
          {{ props.primaryCtaText || $t('landing.cta_signup') }}
        </NuxtLink>
        <a :href="props.secondaryCtaLink || '#pricing'" class="btn-cyber-secondary btn-cta">
          {{ props.secondaryCtaText || $t('landing.cta_plans') }}
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  title: String,
  subtitle: String,
  primaryCtaText: String,
  primaryCtaLink: String,
  secondaryCtaText: String,
  secondaryCtaLink: String,
})
const localePath = useLocalePath()
</script>

<style scoped>
/* Mobile-first. Ladder: 480 / 640 / 768 / 1024 / 1280 (variables.css). */
.cta-section {
  position: relative;
  padding: var(--landing-section-pad) 0;
  overflow: hidden;
}

.cta-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background:
    radial-gradient(ellipse at 30% 50%, rgba(0, 242, 255, 0.06) 0%, transparent 60%),
    radial-gradient(ellipse at 70% 50%, rgba(255, 107, 107, 0.06) 0%, transparent 60%);
}

.cta-grid-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    linear-gradient(rgba(255, 120, 120, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 107, 107, 0.04) 1px, transparent 1px);
  background-size: 40px 40px;
  opacity: 0.5;
}

/* Small + lightly blurred on phones; full glow from tablet up. */
.cta-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.12;
}

.cta-orb-1 {
  top: -60px;
  left: 20%;
  width: 200px;
  height: 200px;
  background: var(--primary);
}

.cta-orb-2 {
  bottom: -60px;
  right: 20%;
  width: 200px;
  height: 200px;
  background: var(--secondary, #ff6b6b);
}

@media (min-width: 768px) {
  .cta-orb {
    filter: blur(120px);
  }

  .cta-orb-1 {
    top: -100px;
    width: 400px;
    height: 400px;
  }

  .cta-orb-2 {
    bottom: -100px;
    width: 400px;
    height: 400px;
  }
}

.cta-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 680px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

.cta-title {
  font-family: var(--font-heading);
  font-size: var(--landing-title-size);
  font-weight: 800;
  line-height: 1.15;
  color: #fff;
  margin-bottom: var(--space-4);
  text-wrap: balance;
}

.gradient-text {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.cta-subtitle {
  font-size: var(--landing-sub-size);
  color: var(--text-muted);
  margin-bottom: var(--space-8);
  line-height: 1.6;
}

.cta-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
}

.btn-cta {
  height: 48px !important;
  padding: 0 28px !important;
  font-size: 0.75rem !important;
  width: 100%;
  max-width: 300px;
}

@media (min-width: 480px) {
  .cta-buttons {
    flex-direction: row;
    justify-content: center;
    gap: var(--space-4);
  }

  .btn-cta {
    width: auto;
  }
}
</style>
